/* ============================================================================
   THE HOUSE HAND — card-game email capture
   ----------------------------------------------------------------------------
   The hand is genuinely dealt. A full 52-card deck is shuffled with Fisher–Yates
   using Math.random, the cards come off the top, and the dealer follows one
   published rule: draw below 17, stand on 17 and up. No outcome is decided in
   advance and no result is weighted. The on-screen copy says the game is real,
   so it has to be.

   Win or push pays the better code; a loss pays the standard one. Both are told
   to the visitor before a card is turned.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('CardGamePopup');
  if (!root) return;

  var STORE_KEY = 'zenith_popup';   /* shared with the quiz popup on purpose:
                                       whichever ran, a subscriber is done. */
  var hideDays  = parseInt(root.dataset.hideDays, 10) || 30;
  var delay     = parseInt(root.dataset.delay, 10) || 12000;

  var PRIZE = {
    win:  { code: root.dataset.winCode,  pct: parseInt(root.dataset.winPct, 10) },
    lose: { code: root.dataset.loseCode, pct: parseInt(root.dataset.losePct, 10) }
  };

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- elements ---------------------------------------------------------- */
  var q = function (sel) { return root.querySelector(sel); };
  var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  var dealerHand  = q('[data-dealer-hand]');
  var playerHand  = q('[data-player-hand]');
  var dealerTotal = q('[data-dealer-total]');
  var playerTotal = q('[data-player-total]');
  var hitBtn      = q('[data-hit]');
  var standBtn    = q('[data-stand]');
  var intro       = q('[data-intro]');
  var resultSub   = q('[data-result-sub]');
  var claim       = q('[data-claim]');
  var verdict     = q('[data-verdict]');
  var prizeLine   = q('[data-prize]');
  var tagsField   = q('[data-tags]');
  var claimForm   = q('#CardGameClaimForm');
  var claimBtn    = q('[data-claim-btn]');
  var claimedSub  = q('[data-claimed-sub]');
  var codeOut     = q('[data-code-out]');
  var shopLink    = q('[data-shop-link]');
  var downcard    = q('[data-downcard]');
  var flipBtn     = q('[data-flip]');
  var summitWrap  = q('[data-summit]');
  var summitDone  = q('[data-summit-done]');
  var summitForm  = q('#CardGameSummitForm');
  var summitEmail = q('[data-summit-email]');

  /* ---- deck -------------------------------------------------------------- */
  var RANKS = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];
  var SUITS = [
    { glyph: '♠', name: 'spades',   red: false },
    { glyph: '♥', name: 'hearts',   red: true  },
    { glyph: '♦', name: 'diamonds', red: true  },
    { glyph: '♣', name: 'clubs',    red: false }
  ];

  var deck = [];
  var dealer = [];
  var player = [];
  var settled = false;

  function buildDeck() {
    deck = [];
    for (var s = 0; s < SUITS.length; s++) {
      for (var r = 0; r < RANKS.length; r++) {
        deck.push({ rank: RANKS[r], suit: SUITS[s] });
      }
    }
    /* Fisher–Yates, back to front. */
    for (var i = deck.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = deck[i]; deck[i] = deck[j]; deck[j] = t;
    }
  }

  function draw() { return deck.pop(); }

  /* Aces count 11 until that would bust, then 1. Standard soft-hand handling:
     count every ace as 11 first, then demote one at a time while over 21. */
  function total(hand) {
    var sum = 0, aces = 0;
    for (var i = 0; i < hand.length; i++) {
      var r = hand[i].rank;
      if (r === 'A') { aces++; sum += 11; }
      else if (r === 'K' || r === 'Q' || r === 'J' || r === '10') { sum += 10; }
      else { sum += parseInt(r, 10); }
    }
    while (sum > 21 && aces > 0) { sum -= 10; aces--; }
    return sum;
  }

  function isNatural(hand) { return hand.length === 2 && total(hand) === 21; }

  /* ---- rendering --------------------------------------------------------- */
  function cardEl(card, index) {
    var el = document.createElement('span');
    el.className = 'cardgame__card' + (card.suit.red ? ' cardgame__card--red' : '');
    el.setAttribute('role', 'img');
    el.setAttribute('aria-label', card.rank + ' of ' + card.suit.name);
    el.innerHTML =
      '<span class="cardgame__rank">' + card.rank + '</span>' +
      '<span class="cardgame__suit">' + card.suit.glyph + '</span>';
    if (!reduceMotion) el.style.animationDelay = (index * 90) + 'ms';
    return el;
  }

  function backEl() {
    var el = document.createElement('span');
    el.className = 'cardgame__card cardgame__card--back';
    el.setAttribute('role', 'img');
    el.setAttribute('aria-label', 'Face-down card');
    el.innerHTML = '<span class="cardgame__mark">Z</span>';
    return el;
  }

  /* holeHidden: while the hand is live the dealer's second card stays face down
     and the total shows only what the player can actually see. */
  function render(holeHidden) {
    playerHand.innerHTML = '';
    player.forEach(function (c, i) { playerHand.appendChild(cardEl(c, i)); });
    playerTotal.textContent = total(player);

    dealerHand.innerHTML = '';
    if (holeHidden) {
      dealerHand.appendChild(cardEl(dealer[0], 0));
      dealerHand.appendChild(backEl());
      dealerTotal.textContent = total([dealer[0]]) + ' + ?';
    } else {
      dealer.forEach(function (c, i) { dealerHand.appendChild(cardEl(c, i)); });
      dealerTotal.textContent = total(dealer);
    }
  }

  /* ---- play -------------------------------------------------------------- */
  function start() {
    buildDeck();
    dealer = [draw(), draw()];
    player = [draw(), draw()];
    settled = false;
    render(true);

    if (isNatural(player)) {
      /* A natural pays immediately — the player never gets to act, so acting on
         it would be theatre. Dealer natural at the same time is a push. */
      finish(isNatural(dealer) ? 'push' : 'blackjack');
    }
  }

  function hit() {
    if (settled) return;
    player.push(draw());
    render(true);
    if (total(player) > 21) finish('bust');
    else if (total(player) === 21) stand();
  }

  function stand() {
    if (settled) return;
    while (total(dealer) < 17) dealer.push(draw());

    var d = total(dealer);
    var p = total(player);
    if (d > 21) finish('dealer-bust');
    else if (d > p) finish('lose');
    else if (p > d) finish('win');
    else finish('push');
  }

  /* ---- outcomes ---------------------------------------------------------- */
  var COPY = {
    blackjack:     { won: true,  head: 'Twenty-one.',        sub: 'On the first two cards. Nothing to play.' },
    'dealer-bust': { won: true,  head: 'The house went over.', sub: 'Your hand stands.' },
    win:           { won: true,  head: 'You beat the house.',  sub: 'Closer to 21.' },
    push:          { won: true,  head: 'A push.',              sub: 'Dead even — and the house does not take from a draw.' },
    bust:          { won: false, head: 'Over twenty-one.',     sub: 'The house takes it.' },
    lose:          { won: false, head: 'The house takes it.',  sub: 'Closer to 21 this time.' }
  };

  function finish(outcome) {
    settled = true;
    render(false);

    var c = COPY[outcome];
    var prize = c.won ? PRIZE.win : PRIZE.lose;

    hitBtn.disabled = true;
    standBtn.disabled = true;

    intro.hidden = true;
    resultSub.hidden = false;
    resultSub.textContent = c.sub;

    verdict.textContent = c.head;
    prizeLine.textContent = c.won
      ? prize.pct + '% off your order.'
      : prize.pct + '% off your order — you do not leave empty.';

    if (tagsField) tagsField.value += ',' + (c.won ? 'game-win' : 'game-lose');
    if (claimBtn) claimBtn.textContent = 'Claim my ' + prize.pct + '%';

    root.dataset.outcome = c.won ? 'win' : 'lose';
    claim.hidden = false;

    var focusTarget = root.querySelector('#CardGameEmail');
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 260);
  }

  /* ---- form posting ------------------------------------------------------
     These forms submit as ordinary page navigations. They are NOT AJAXed, and
     that is deliberate — an earlier build fetch()ed the form body to /contact
     and every request came back 400, including a payload byte-identical to the
     footer newsletter form's.

     The cause: this store has Shopify's spam protection on
     (`window.Shopify.captcha === true`). Shopify listens for the form's submit
     event, obtains a CAPTCHA token and only then posts. A fetch() skips that
     listener entirely, so the request arrives with no token and is rejected —
     the response page is literally titled "Missing CAPTCHA token".

     There is no way to add the token by hand from here, so the form must submit
     the way Shopify expects. The cost is a page reload, which is why the game
     outcome is written to localStorage first and restored on the way back in.
     sections/signup-popup.liquid solved it the same way for the same reason.

     Do not "improve" this into an AJAX call. It has been tried and it 400s.
     ---------------------------------------------------------------------- */
  var GAME_KEY = 'zenith_game';

  function saveGame(data) {
    try { localStorage.setItem(GAME_KEY, JSON.stringify(data)); } catch (e) {}
  }
  function loadGame() {
    try { return JSON.parse(localStorage.getItem(GAME_KEY)) || null; } catch (e) { return null; }
  }
  function clearGame() {
    try { localStorage.removeItem(GAME_KEY); } catch (e) {}
  }

  function showScreen(name) {
    qa('.cardgame__screen').forEach(function (s) {
      s.classList.toggle('is-active', s.dataset.screen === name);
    });
    var panel = q('.cardgame__panel');
    if (panel) panel.scrollTop = 0;
  }

  /* Renders the claimed screen for a given outcome. Used both on the way back
     from a submit and never anywhere else — the code shown must always come
     from a stored outcome, not from whatever hand happens to be on screen. */
  function renderClaimed(outcome, email) {
    var prize = outcome === 'win' ? PRIZE.win : PRIZE.lose;
    codeOut.textContent = prize.code;
    claimedSub.textContent = prize.pct + '% off — the code is below, and it is in your inbox too.';
    shopLink.href = '/discount/' + encodeURIComponent(prize.code) + '?redirect=/collections/all';
    if (summitEmail && email) summitEmail.value = email;
    showScreen('claimed');
  }

  if (claimForm) {
    /* No preventDefault: the browser submits, Shopify's CAPTCHA handler runs,
       the page reloads with ?customer_posted=true and init() picks it back up.
       Everything needed to rebuild the screen is written before we let go. */
    claimForm.addEventListener('submit', function () {
      var emailField = claimForm.querySelector('#CardGameEmail');
      saveGame({
        outcome: root.dataset.outcome === 'win' ? 'win' : 'lose',
        stage: 'claimed',
        email: emailField ? emailField.value : ''
      });
      setState({ status: 'subscribed' });
      claimBtn.disabled = true;
      claimBtn.textContent = 'One moment';
    });
  }

  if (flipBtn) {
    flipBtn.addEventListener('click', function () {
      flipBtn.classList.add('is-flipping');
      setTimeout(function () {
        downcard.hidden = true;
        summitWrap.hidden = false;
        var f = summitWrap.querySelector('input[type="email"]');
        if (f) f.focus();
      }, reduceMotion ? 0 : 420);
    });
  }

  if (summitForm) {
    /* Same navigation submit as the claim form, one stage further on. */
    summitForm.addEventListener('submit', function () {
      var prev = loadGame() || {};
      prev.stage = 'summit-done';
      saveGame(prev);
      var btn = summitForm.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'One moment'; }
    });
  }

  /* ---- suppression ------------------------------------------------------- */
  function getState() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
  }
  function setState(state) {
    state.ts = Date.now();
    try { localStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {}
  }
  /* Visitors who arrived through a member-card link (/discount/AFC15) already
     hold a better code. The game's prize would replace it in the cart, so the
     popup stays away while that code sits in Shopify's discount_code cookie. */
  var MEMBER_CODES = ['AFC15'];
  function hasMemberCode() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return false;
    var codes;
    try { codes = decodeURIComponent(m[1]).toUpperCase().split(','); } catch (e) { return false; }
    return codes.some(function (c) { return MEMBER_CODES.indexOf(c.trim()) !== -1; });
  }

  function isSuppressed() {
    if (hasMemberCode()) return true;
    var s = getState();
    if (!s.ts) return false;
    if (s.status === 'subscribed') return true;
    return s.status === 'dismissed' && (Date.now() - s.ts) < hideDays * 864e5;
  }

  /* ---- open / close ------------------------------------------------------ */
  var lastFocus = null;

  function reveal() {
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeydown);
  }

  function open() {
    lastFocus = document.activeElement;
    start();
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (hitBtn) hitBtn.focus(); }, 120);
    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    if (getState().status !== 'subscribed') setState({ status: 'dismissed' });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* Keeps tab inside the dialog while it is modal. Without this, tabbing walks
     into the page behind an aria-modal surface, which is the classic modal a11y
     failure. */
  function onKeydown(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;

    var focusable = qa(
      'button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    ).filter(function (el) { return el.offsetParent !== null; });
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  qa('[data-game-close]').forEach(function (el) { el.addEventListener('click', close); });
  if (hitBtn) hitBtn.addEventListener('click', hit);
  if (standBtn) standBtn.addEventListener('click', stand);

  /* ---- init --------------------------------------------------------------
     The returning-from-submit branch is checked FIRST and ignores suppression
     on purpose. The claim handler marks the visitor 'subscribed' before letting
     the form go, so by the time the page comes back isSuppressed() is true — if
     that were checked first, the visitor would post their address and never be
     shown the code they just earned.
     ---------------------------------------------------------------------- */
  var posted = /customer_posted=true/.test(window.location.search);
  var saved = loadGame();

  if (posted && saved && saved.stage) {
    renderClaimed(saved.outcome, saved.email);

    if (saved.stage === 'summit-done' && summitWrap && summitDone) {
      if (downcard) downcard.hidden = true;
      summitWrap.hidden = true;
      summitDone.hidden = false;
      clearGame();          /* nothing left to restore — do not reopen again */
    }

    reveal();
    var landing = root.querySelector('.cardgame__screen.is-active a, .cardgame__screen.is-active button');
    if (landing) setTimeout(function () { landing.focus(); }, 160);
  } else if (!isSuppressed()) {
    setTimeout(open, delay);
  }
})();
